import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import { getFlowKey } from '../routing/getFlowKey';
export const getExistingUserHubletChoice = () => {
  return noPortalApiClient.post('signup/v1/location/existing-user-available-hublets', {
    data: {
      flowKey: getFlowKey()
    }
  });
};